var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"dusk":"logout"},on:{"click":_vm.logout}},[_vm._v("\n    "+_vm._s(_vm.$lang('app.logout'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }